import React from "react";
import { useOutletContext } from "react-router-dom";
import { ClientPlanningView } from "@/domains/Client/components/ClientPlanningView";

interface ApprovalOutletContext {
  clientId: string;
  token?: string;
}

export const ClientPlanningRoute: React.FC = () => {
  const { clientId, token } = useOutletContext<ApprovalOutletContext>();

  return <ClientPlanningView clientId={clientId} token={token} />;
};
